import React from "react";
import { Link } from "react-router-dom";
import { AllPrograms } from "../interfaces/Program";

interface ProgramCardProps {
  program: AllPrograms;
}

export default function ProgramCard({ program }: ProgramCardProps) {
  const formattedDate = new Intl.DateTimeFormat("en-US", {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
  }).format(new Date(program.startDate));

  return (
    <Link
      to={`/program/${program.slug}`}
      className="group bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden flex flex-col h-full border border-gray-100 block"
    >
      <div className="w-full h-60 md:h-64 bg-gray-100 overflow-hidden relative">
        <img
          src={program.icon}
          alt={program.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
      </div>
      <div className="p-4 flex-1 flex flex-col justify-between">
        <div>
          <div className="flex justify-between items-start gap-2 mb-3 min-h-[3.25rem]">
            <h3
              className="text-lg font-semibold text-[#263238] group-hover:text-[#037897] transition-colors leading-snug line-clamp-2 flex-1"
              title={program.title}
            >
              {program.title}
            </h3>
            <span className="text-[#037897] font-bold text-lg whitespace-nowrap pt-0.5">
              ${program.cost}
            </span>
          </div>
          <div className="flex justify-between items-start text-xs mb-4 pt-3 border-t border-gray-100 gap-2">
            <div className="min-w-0">
              <span className="text-[#607D8B] block mb-1">Date</span>
              <p className="font-semibold text-[#263238]">{formattedDate}</p>
            </div>
            <div className="text-right min-w-0">
              <span className="text-[#607D8B] block mb-1 truncate">
                Places réservées & disponibles
              </span>
              <p className="font-semibold text-[#263238]">
                {program.maxParticipants < 9999
                  ? program.bookedSlots
                    ? `${program.bookedSlots} / ${program.maxParticipants}`
                    : `0 / ${program.maxParticipants}`
                  : "No limits"}
              </p>
            </div>
          </div>
        </div>
        <div className="mt-auto pt-2">
          <span className="w-full uppercase bg-[#037897] group-hover:bg-[#02627c] text-white py-3 px-4 font-bold rounded-md text-center text-sm transition-colors duration-200 block shadow-sm">
            Réserver Maintenant
          </span>
        </div>
      </div>
    </Link>
  );
}
